import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';
import Breadcrumbs, { BreadcrumbsItem } from '../../../template/MainTheme/components/Breadcrumbs';
import DefaultCard from '../../../components/default/DefaultCard';
import SalesOrderEdit from '../components/SalesOrderEdit';
import SalesOrderDetailContainer from '../components/SalesOrderDetailContainer';
import { SalesOrderDataForm } from '../../../app/models/SalesOrder';

type RouterParams = {
    id: string;
};

const SalesOrderEditPage = () => {
    const { id } = useParams<RouterParams>();
    const [salesOrder, setSalesOrder] = useState<SalesOrderDataForm | null>(null);

    const breadcrumbs: BreadcrumbsItem[] = [
        {
            name: 'Órdenes de Venta',
            url: '/sales-orders',
            isActive: false
        },
        {
            name: 'Editar #' + id,
            url: '/sales-orders/' + id + '/edit',
            isActive: true
        }
    ];

    const formatDate = (d?: string | null) => {
        if (!d) return '';
        try {
            const date = new Date(d);
            return Number.isNaN(date.getTime()) ? (d as string) : date.toLocaleDateString();
        } catch {
            return d as string;
        }
    };

    const createdByName = (salesOrder as any)?.created_by_name || '';
    const updatedByName = (salesOrder as any)?.updated_by_name || '';

    return (
        <>
            <Breadcrumbs pageSection={`Editar Orden de Venta #${id}`} breadcrumbs={breadcrumbs} />

            {/* Tabs superiores */}
            <Tabs defaultActiveKey="general" id="so-edit-top-tabs" className="mb-3">
                {/* === TAB 1: Datos Generales === */}
                <Tab eventKey="general" title="Datos Generales">
                    {/* Fila con 2 contenedores separados */}
                    <div className="row">
                        {/* Contenedor izquierdo: Datos Generales */}
                        <div className="col-12 col-lg-8">
                            <DefaultCard>
                                <h5 className="mb-3">Datos Generales</h5>
                                <SalesOrderEdit
                                    salesOrderId={parseInt(id)}
                                    onSaved={undefined}
                                    onSalesOrderChange={setSalesOrder}
                                />
                            </DefaultCard>
                        </div>

                        {/* Contenedor derecho: Datos del creador */}
                        <div className="col-12 col-lg-4">
                            <DefaultCard>
                                <h5 className="mb-3">Datos del creador</h5>
                                <div className="mb-2">
                                    <label className="form-label">Creado por</label>
                                    <input className="form-control" value={createdByName} disabled />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Fecha de creación</label>
                                    <input className="form-control" value={formatDate((salesOrder as any)?.created_at)} disabled />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Editado por</label>
                                    <input className="form-control" value={updatedByName} disabled />
                                </div>
                                <div className="mb-2">
                                    <label className="form-label">Fecha de actualización</label>
                                    <input className="form-control" value={formatDate((salesOrder as any)?.updated_at)} disabled />
                                </div>
                                <hr />
                                <div className="mb-2">
                                    <label className="form-label">Activo</label>
                                    <input className="form-control" value={salesOrder?.is_active ? 'Sí' : 'No'} disabled />
                                </div>
                            </DefaultCard>
                        </div>
                    </div>
                </Tab>
            </Tabs>

            {/* Posiciones */}
            <SalesOrderDetailContainer
                salesOrderId={parseInt(id)}
                orderCurrencyId={salesOrder?.currency_id}
                isShow={false}
            />
        </>
    );
};

export default SalesOrderEditPage;

